import { render, staticRenderFns } from "./SkinPanel.vue?vue&type=template&id=c898573e&"
import script from "./SkinPanel.vue?vue&type=script&lang=js&"
export * from "./SkinPanel.vue?vue&type=script&lang=js&"
import style0 from "./SkinPanel.vue?vue&type=style&index=0&id=c898573e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports